import {
  ONBOARDING_SENDING_EMAIL,
  ONBOARDING_TOUR_COMPLETED,
  ONBOARDING_UDPATE,
} from 'constants/actions';

const DEFAULT_ONBOARDING_STATE = {
  tours_completed: {},
  sendingDownloadEmail: false,
};

const onboardingReducer = (state = DEFAULT_ONBOARDING_STATE, action) => {
  switch (action.type) {
    case ONBOARDING_SENDING_EMAIL:
      return { ...state, sendingDownloadEmail: action.sendingDownloadEmail };

    case ONBOARDING_TOUR_COMPLETED:
      return {
        ...state,
        tours_completed: {
          ...state.tours_completed,
          [action.tour]: true,
        },
      };

    case ONBOARDING_UDPATE:
      return {
        ...state,
        tours_completed: action.completed,
      };

    default:
      return state;
  }
};

export default onboardingReducer;
